import React from 'react';
import SHA256 from 'crypto-js/sha256';
import encUtf8 from 'crypto-js/enc-utf8';


function createHash(input) {
    const wordArray = encUtf8.parse(input);
    const hash = SHA256(wordArray);
   // console.log(hash.toString().toLowerCase());

    return hash.toString().toLowerCase();
}

export default createHash;
